import React, { useState, useEffect } from 'react';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import $ from 'jquery';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';

import { getMonth, formatDate } from '@utils';
import { IsEnglish } from '@utils/language';
import styles from '@styles/punch.module.css';
import * as punchListType from '@scripts/PunchListType';
import { todaysCCQPunches, ccqPunchesOfTheWeek, detailPunchCCQ } from '@actions/timesheet';
import PunchCCQDetail from '@components/punchCCQ/PunchCCQDetail';
import DescriptionWeekDay from '@components/punchCCQ/DescriptionWeekDay'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        paddingBottom: '10px!important',
        color: '#3f51b5 !important'
    },
    divDate: {
        fontWeight: 'bold',
        color: 'var(--color1)',
        borderRadius: '10px',
        marginTop: '10px',
        textAlign: 'center'
    },
    divNoEntry: {
        textAlign: 'center'
    }
}));

export function PunchCCQList(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [dataDetail, setDataDetail] = useState({});
    const [open, setOpen] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [dayOrWeek, setDayOrWeek] = useState(props.punchListType);

    useEffect(() => {
        resizeList();
    }, []);

    useEffect(() => {
        loadPunches();
    }, [props.loader, props.dates]);

    useEffect(() => {
        if (Object.keys(dataDetail).length > 0) {
            if (!open) {
                setOpen(true);
            }
        }
    }, [dataDetail]);

    const loadPunches = () => {
        setIsActive(true);
        if (dayOrWeek == punchListType.DAY) {
            loadTodaysCCQPunches();
        }
        else if (dayOrWeek == punchListType.WEEK) {
            loadCCQPunchesOfTheWeek(props.dates.startDate);
        }
    }

    const loadTodaysCCQPunches = () => {
        todaysCCQPunches().then((response) => {
            if (response && response.punch) {
                const punches = JSON.parse(response.punch);
                setData(punches);
                setIsActive(false);

                let activePunchResult = 0;
                let hasPunchResult = false;
                if (Array.isArray(punches) && punches.length > 0 && Array.isArray(punches[0].ListDetail) && punches[0].ListDetail.length > 0) {
                    punches[0].ListDetail.forEach(function (punch, index) {
                        if (!punch.PunchRealEnd && punch.PunchId > 0 && !punch.IsExpired) {
                            activePunchResult = punch.PunchId;
                        }
                        hasPunchResult = true;
                    });
                }

                if (props.handlePunchState) {
                    props.handlePunchState(activePunchResult, hasPunchResult);
                }
            }
        });
    }

    const loadCCQPunchesOfTheWeek = (startDate) => {
        if (startDate) {
            ccqPunchesOfTheWeek(startDate).then((response) => {
                setData(JSON.parse(response.punch));
                setIsActive(false);
            });
        }
    }

    const handleClick = (punchId) => {
        detailPunch(punchId);
    }

    const detailPunch = (punchId) => {
        loadDetail(punchId);
    }

    const loadDetail = (punchId) => {
        detailPunchCCQ(punchId).then((response) => {
            if (response) {
                setDataDetail(JSON.parse(response.detail));
            }
        });
    }

    const resizeList = () => {
        setTimeout(function () {
            const height = $('body').height();
            const header = $('.makeStyles-root-1').height();

            const customHeight = height - header;

            $('div[data-id=divList]').css('height', `${customHeight}px`);
        }, 1000);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const divDate = (data) => {
        return (
            data && data.map((obj, index) =>
                <div key={index}>
                    {dayOrWeek == punchListType.WEEK && <div className={classes.divDate}>
                        <DescriptionWeekDay date={obj.Date} /> {!IsEnglish() && (new Date(obj.Date)).getDate()} {getMonth(new Date(obj.Date), IsEnglish())} {IsEnglish() && (new Date(obj.Date)).getDate()}
                    </div>}
                    <div className={classes.paymentCell}>
                    </div>
                    <List>
                        {divContent(obj.ListDetail)}
                    </List>
                </div>
            )
        );
    }

    const divContent = (data) => {
        if (data && Array.isArray(data) && data.length > 0) {
            return (
                data.map((obj, index) =>
                    <React.Fragment key={index}>
                        <ListItem className="listItem" key={index} button onClick={() => handleClick(obj.PunchId)}>
                            <ListItemText disableTypography={true} primary={
                                <React.Fragment>
                                    <div className={styles.projectPunchList}>
                                        {obj.Project != null && `${obj.Project}${i18next.t('common:dashSeparator')} ${IsEnglish() ? obj.ProjectDescE : obj.ProjectDescF}`}
                                        {obj.Project == null && '\u00A0'}
                                    </div>
                                    <div className={styles.jobTitlePunchList}>
                                        {obj.Function != null && `${obj.Function}${i18next.t('common:dashSeparator')} ${IsEnglish() ? obj.JobTitleDescE : obj.JobTitleDescF}`}
                                        {obj.Function == null && '\u00A0'}
                                    </div>
                                    <div className={styles.departmentPunchList}>
                                        {obj.DepartmentCode != null && `${obj.DepartmentCode}${i18next.t('common:dashSeparator')} ${IsEnglish() ? obj.DepartmentPayDescE : obj.DepartmentPayDescF}`}
                                        {obj.DepartmentCode == null && '\u00A0'}
                                    </div>
                                    {obj.SalaryTable != null &&
                                        <div className={styles.jobTitlePunchList}>
                                            {obj.SalaryTable != null && `${obj.SalaryTable}${i18next.t('common:dashSeparator')} ${IsEnglish() ? obj.CCQSalaryTableDescE : obj.CCQSalaryTableDescF}`}
                                            {obj.SalaryTable == null && '\u00A0'}
                                        </div>
                                    }
                                    <div className={`${styles.timePunchList}`}>
                                        <div className={styles.punchTimeIconContainer}><AccessTimeIcon className={classes.icons} /></div>
                                        <span>
                                            {obj.PunchRealStart != null && `${formatDate(obj.PunchRealStart, 'time')}`}
                                            {obj.PunchRealStart != null && obj.PunchRealEnd != null && `${i18next.t('common:dashSeparator')}${formatDate(obj.PunchRealEnd, 'time')}`}
                                        </span>
                                        {obj.PunchRealStart == null && '\u00A0'}
                                    </div>
                                </React.Fragment>
                            } />
                        </ListItem>
                    </React.Fragment>
                )
            );
        }
        return (<div className={`${classes.divNoEntry}`}>{i18next.t('punchCCQ:message.no-day-data')}</div> );
    }

    return (
        <LoadingOverlay
            active={isActive}
            spinner={<BeatLoader />}
            text={i18next.t('punch:form.loading')}
        >
            <div data-id="divList" className={styles.konekCard}>
                <div id={"divRoot"} className={classes.divRoot}>
                    {divDate(data)}
                </div>

                <PunchCCQDetail open={open} onClose={handleClose} data={dataDetail} />
            </div>
        </LoadingOverlay>
    )
}

export default withNamespaces(['punch', 'common', 'punchCCQ'], { wait: true })(PunchCCQList);